import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/basic-info/customer-list`;

export const customerListRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:customerId`,
  view: `${baseRoute}/view/:customerId`,
  viewSalesInvoices: `${baseRoute}/view/:customerId/sales-invoices`,
  fullDebtSettlement: `${baseRoute}/view/:customerId/full-debt-settlement`,
  sendMessage: `${baseRoute}/:customerId/send-message`,
} as const;

export type ICustomerListRouteParams = IExtractRouteParamMap<
  typeof customerListRoutesObj
>;

export const customerListPath = createPaths<
  typeof customerListRoutesObj,
  ICustomerListRouteParams
>(customerListRoutesObj);
